import React, { useState } from 'react'

// Material Ui
import Box from '@material-ui/core/Box'

// Style
import { makeStyles } from "@material-ui/core/styles"

// Toggle Button - LAB
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'

// Icons
import AddIcon from '@material-ui/icons/Add'
import BlockIcon from '@material-ui/icons/Block'

const useStyles = makeStyles((theme) => ({
    selectedExtra: {
        backgroundColor: "#b6ffaf !important",
    },
    selectedWithout: {
        backgroundColor: "#fca99c !important",
    },
}));

export default function IngredientsChoice({ ingredient, handleChange }) {

    const [choice, setChoice] = useState()
    const classes = useStyles()

    const handleChoice = (event, choice) => {
        setChoice(choice)
        handleChange(ingredient, choice)
    }

    return (
        <>
            <ToggleButtonGroup
                value={choice}
                exclusive
                onChange={handleChoice}
            >
                <ToggleButton classes={{ selected: classes.selectedWithout }} value="w" aria-label="centered">
                    <BlockIcon />
                </ToggleButton>
                <ToggleButton classes={{ selected: classes.selectedExtra }} value="+" aria-label="right aligned">
                    <AddIcon />
                    <Box style={{ width: 55 }} fontWeight="fontWeightBold">{ingredient.Price !== 0 && ("(" + ingredient.Price.toFixed(2) + "$)")}</Box>
                </ToggleButton>
            </ToggleButtonGroup>
        </>
    )
}